import { Component, OnInit } from '@angular/core';
import { Select2Data } from 'ng-select2-component';
declare let $: any;
@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank-layout.component.html',
  styleUrls: ['./blank-layout.component.scss'],
})
export class BlankLayoutComponent implements OnInit {
  dynamicHeader;
  relatedSearch;
  mnuHide;
  sbmnuHide;
  public page = 1;
  public count = 0;
  public pageSize = 10;
  public from;
  public to;
  search: Select2Data = [
    { label: 'Application', value: 0 },
    { label: 'Role', value: 1 },
    { label: 'Menu', value: 2 },
    { label: 'Submenu', value: 3 },
  ];
  roleMenu = [
    {
      org_name: 'SSA',
      app_desc: 'Configuration',
      menu_desc: 'Setups',
      sub_desc: 'Org',
      role_desc: 'Admin',
      status: '1',
      map_id: '2',
    },
  ];
  constructor() {}

  ngOnInit(): void {}

  openModal(id, header): void {
    this.dynamicHeader = header;
    $(id).modal('show');
  }

  resetSearch(): void {
    this.relatedSearch = '';
  }
  getNumberPerPage(event): void {
    this.pageSize = event.target.value;
  }
  handlePageChange(event): void {
    this.page = event;
  }
}
